import { render, staticRenderFns } from "./WorkstationForm.vue?vue&type=template&id=ba1855ba"
import script from "./WorkstationForm.vue?vue&type=script&lang=js"
export * from "./WorkstationForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports